import { ITroubledCustomer } from "../../interfaces/TroubledCustomers";

export const validateTroubledCustomer = (customer: Partial<ITroubledCustomer>): string | null => {
  const { customerName, eventType, activities, eventDate, eventTime, description, compensationType } = customer;

  if (!customerName) return "Please make sure Customer Name input is not empty.";
  if (!eventType) return "Please make sure Event Type is selected.";
  if (!eventDate) return "Please make sure Event date is picked";
  if (!eventTime) return "Please make sure Event time is selected.";
  if (!description) return "Please make sure description input is not empty.";
  if (!compensationType || compensationType === "Select Compensation Type") return "Please make sure compensation type is selected.";
  if (!activities || !activities.length) return "Please make sure activities are selected.";

  return null;
}; 